import React from 'react';
import { EmailProvider } from 'nekst-api';
import BaseProviderCard, { ProviderCardProps, ProviderConfig } from './BaseProviderCard';
import gmailIcon from './gmail.png';

const GMAIL_CONFIG: ProviderConfig = {
  name: 'Gmail',
  icon: gmailIcon,
  provider: EmailProvider.GMAIL,
  lockedByProvider: 'Outlook',
};

export default function GmailProviderCard(props: ProviderCardProps) {
  return <BaseProviderCard config={GMAIL_CONFIG} {...props} />;
}
